<template>
	<div class='housemaid'>
		<v-layout>
			<div class="text top">
				<v-subheader>Datos de la mucama</v-subheader>
					<v-select
						v-bind:items="sucursales"
						v-model="selected.sucursal"
						label="Sucursal"
						single-line
						bottom
					></v-select>
			</div>
			<div class="text top">
				<v-subheader></v-subheader>
					<v-select
						v-bind:items="buildings"
						v-model="selected.building"
						label="Edificio"
						single-line
						bottom
					></v-select>
			</div>
		</v-layout>
		<v-layout row>
			<v-flex class="xs12 input-text fullname">
				<v-text-field
					name="input 1"
					label="Nombres completos"
					v-model="housemaid.fullname"
					single-line
            	></v-text-field>
			</v-flex>
		</v-layout>
		<v-layout row>
			<v-flex class="picture-housemaid">
				<v-subheader v-if="true">Foto de perfil</v-subheader>
				<v-card>
					<v-card-media src="#">
					</v-card-media>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout>
			<div class="top country">
				<v-subheader>País</v-subheader>
				<v-select
					v-bind:items="countries"
					v-model="housemaid.contry"
					label="Perú"
					single-line
					bottom
				></v-select>
			</div>
			<div class="top">
				<v-subheader>Género</v-subheader>
				<v-select
					v-bind:items="genders"
					v-model="housemaid.gender"
					label="Varón"
					single-line
					bottom
				></v-select>
			</div>
			<div class="top ">
				<v-subheader>Fecha de nacimiento</v-subheader>
				<v-menu
					lazy
					:close-on-content-click="false"
					v-model="menuDateBorn"
					transition="scale-transition"
					offset-y
					full-width
					:nudge-left="40"
					max-width="290px"
					>
					<v-text-field
						slot="activator"
						v-model="housemaid.dateBorn"
						bottom
						readonly
						single-line
						label="28-12-2017"
					></v-text-field>
					<v-date-picker v-model="housemaid.dateBorn" no-title scrollable actions>
						<template 
							scope="{ save, cancel }">
							<v-card-actions>
								<v-btn flat primary @click.native="cancel()">Cancelar</v-btn>
								<v-btn flat primary @click.native="save()">Guardar</v-btn>
							</v-card-actions>
						</template>
					</v-date-picker>
				</v-menu>
			</div>
		</v-layout>
		<v-layout>
			<div class="top civil-status">
				<v-subheader>Estado civil</v-subheader>
				<v-select
					v-bind:items="civilStatus"
					v-model="housemaid.civilStatus"
					label="Soltera"
					single-line
					bottom
				></v-select>
			</div>
			<div class="top input-text son">
				<v-subheader>Hijos</v-subheader>
				<v-text-field
					name="sonInputTxt"
					v-model="housemaid.sons"
					label="0"
					single-line
					bottom
				></v-text-field>
			</div>
			<div class="top">
				<v-subheader>Fecha de sanidad</v-subheader>
				<v-menu
					lazy
					:close-on-content-click="false"
					v-model="menuDateHelth"
					transition="scale-transition"
					offset-y
					full-width
					:nudge-left="40"
					max-width="290px"
					>
					<v-text-field
						slot="activator"
						v-model="housemaid.dateHelth"
						single-line
						bottom
						readonly
						label="28-12-2017"
					></v-text-field>
					<v-date-picker v-model="housemaid.dateHelth" no-title scrollable actions>
						<template scope="{ save, cancel }">
							<v-card-actions>
							<v-btn flat primary @click.native="cancel()">Cancelar</v-btn>
							<v-btn flat primary @click.native="save()">Guardar</v-btn>
							</v-card-actions>
						</template>
					</v-date-picker>
				</v-menu>
			</div>
		</v-layout>
		<v-layout>
			<v-flex class="languages md6">
				<v-subheader>Manejo de idiomas:</v-subheader>
				<v-checkbox 
					v-for="language in languages"
					:key="language.id"
					v-bind:label="language.text" 
					v-model="housemaid.languages" 
					v-bind:value="language.text">
				</v-checkbox>
			</v-flex>
		</v-layout>
		<v-layout>
			<v-flex md2 class="save-btn-housemaids">
				<v-btn>Guardar</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
export default {
	name: 'housemaids-new',
	data() {
		return {
			selected: {},
			sucursales: [
				{ id: 1, text: 'Sucursal 1' },
				{ id: 2, text: 'Sucursal 2' },
			],
			buildings: [
				{ id: 1, text: 'building 1' },
				{ id: 2, text: 'building 2' },
			],
			countries: [
				{ id: 1, text: 'Perú' },
				{ id: 2, text: 'Venezuela' },
			],
			genders: [
				{ id: 1, text: 'Caballero' },
				{ id: 2, text: 'Dama' },
			],
			civilStatus: [
				{ id: 1, text: 'Casada' },
				{ id: 2, text: 'Soltera' },
				{ id: 3, text: 'Divorciada' },
				{ id: 4, text: 'Viuda' },
			],
			languages: [
				{ id: 1, text: 'Español' },
				{ id: 2, text: 'Inglés' },
				{ id: 3, text: 'Francés' },
				{ id: 4, text: 'Ruso' },
				{ id: 5, text: 'Griego' },
				{ id: 6, text: 'Portugués' },
				{ id: 7, text: 'Alemán' },
				{ id: 8, text: 'Italiano' },
				{ id: 9, text: 'Sueco' },
			],
			housemaid: {
				languages: [],
				dateBorn: null,
				dateHelth: null,
			},
			modal: false,
			menuDateBorn: false,
			menuDateHelth: false,
			today: Date.now(),
		};
	},
};
</script>

<style lang="scss" scoped>
.housemaid {
	.top {
		margin-right: 15px;
		.input-group--select {
			background-color: white;
		}
		.input-group--select{
			background-color: map-get($colors, red);
			box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
			display: inline-flex;
			float: left;
			height: 40px;
			margin-right: 20px;
			max-width: 190px;
			.input-group__selections {
				margin-left: 15px;
			}
		}
	}
	.top .subheader{
		height: 21px;;
		margin-bottom: 8px;
		padding: 0;
		width: 190px;
	}
	.text .subheader {
		font-weight: map-get($weights, w-six);
	}
	.input-group {
		flex-wrap: nowrap;
		padding: 0;
	}
	.input-text {
		.input-group {
			background-color: white;
		}
		.input-group--text-field {
			background-color: map-get($colors, bg-wht);
			box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);
			height: 40px;
		}
	}
	.fullname {
		.input-group--text-field {
			margin-top: 21px;
			width: 400px;
		}
	}
	.picture-housemaid {
		.subheader {
			height: auto;
			margin-bottom: 9px;
			margin-top: 16px;
			padding: 0;
		}
		.card {
			background-color: white;
			margin-bottom: 23px;
			width: 400px;
			.card__media {
				height: 166px !important;
			}
		}
	}
	.country {
		margin-bottom: 31px;
	}
	.civil-status {
		margin-bottom: 23px;
		.son {
			.input-group--text-field {
				width: 190px;
			}
		}
	}
	.menu {
		background-color: white;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
		height: 40px;
	}
	.languages {
		margin-bottom: 21px;

		.subheader {
			height: auto;
			padding: 0;
			margin-bottom: 11px;
		}
		.checkbox {
			float: left;
			width: 110px;
			.input-group__input .icon {
				transform: scale(0.5);
				
			}
		}
	}
	.save-btn-housemaids {
		button.btn{
			background-color: map-get($colors, default-skyblue);
			box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
			color: white;
			float: left;
			font-weight: map-get($weights, w-six);
			height: 38px;
			margin: 0;
			width: 164px;
			
		}
	}
}
</style>



// WEBPACK FOOTER //
// Create.vue?0b908559